import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";

const BannerContainer = styled.div`
  padding: ${rem("95px")};
  width: 100%;
  height: ${rem("319px")};

  ${({ backgroundImg }) => css`
    background-image: url(${backgroundImg});
    background-size: cover;
    background-position: center;
  `}

  ${({ coloredTiles, primaryColor }) =>
    coloredTiles == "true" &&
    css`
      background-image: unset;
      background-color: #${primaryColor};
    `}
`;

const BannerText = styled.div`
  color: #ffffff;
  text-align: center;
  font-size: ${rem("46px")};
  font-weight: 600;
  margin-bottom: ${rem("20px")};
  line-height: ${rem("42px")};

  ${({ type }) =>
    type == "subtitle" &&
    css`
      margin: 0 auto;
      max-width: ${rem("516px")};
      font-size: ${rem("20px")};
      font-weight: 400;
      line-height: ${rem("32px")};
    `}
`;

const Banner = ({
  backgroundImg,
  title,
  subtitle,
  coloredTiles,
  primaryColor,
}) => {
  return (
    <BannerContainer
      backgroundImg={backgroundImg}
      coloredTiles={coloredTiles}
      primaryColor={primaryColor}
    >
      <BannerText>{title}</BannerText>
      <BannerText type="subtitle">{subtitle}</BannerText>
    </BannerContainer>
  );
};

Banner.propTypes = {
  backgroundImg: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string,
};

export default Banner;
